import { useEffect, useRef, useState } from "react";
import { getCase } from "../../content/lookups.js";
import type { NodeDefinition, NodeId } from "../../domain/types/index.js";
import { useGame } from "../../app/GameProvider.js";
import { MapGraph, nodeById } from "./MapGraph.js";
import { mapNodeVisual } from "./mapPeek.js";
import { NodeDetailSheet } from "./NodeDetailSheet.js";

export function MapPeekOverlay({ onClose }: { onClose: () => void }) {
  const { state } = useGame();
  const [selectedId, setSelectedId] = useState<NodeId | null>(null);
  const dialogRef = useRef<HTMLDivElement>(null);
  const run = state.run;

  useEffect(() => {
    dialogRef.current?.focus();
    const current = dialogRef.current?.querySelector(".map-node.is-current");
    if (current && typeof current.scrollIntoView === "function") {
      current.scrollIntoView({ block: "center" });
    }
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!run) return null;

  const selected = selectedId ? nodeById(selectedId, run.stageId) ?? null : null;
  const handleSelect = (node: NodeDefinition) =>
    setSelectedId((prev) => (prev === node.id ? null : node.id));

  return (
    <div className="overlay map-peek-overlay" role="presentation">
      <div
        ref={dialogRef}
        className="map-peek"
        role="dialog"
        aria-modal="true"
        aria-label="マップ"
        tabIndex={-1}
      >
        <header className="map-peek-head">
          <h2>この先のマス</h2>
          <button type="button" className="btn" onClick={onClose}>
            戻る
          </button>
        </header>
        <div className="map-scroll">
          <MapGraph run={run} screen={state.screen} selectedId={selectedId} onSelect={handleSelect} />
        </div>
      </div>
      {selected && (
        <NodeDetailSheet
          node={selected}
          spec={(selected.caseId ? getCase(selected.caseId) : null) ?? null}
          visual={mapNodeVisual(selected.id, run, state.screen)}
          stageId={run.stageId}
          canProceed={false}
          onClose={() => setSelectedId(null)}
          onProceed={() => {}}
        />
      )}
    </div>
  );
}
